export const cut = (str, max) => {
  if (!str) return '';

  if (str.length <= max) {
    return str;
  }

  return str.substr(0, max) + '...';
};
